module.exports = __webpack_public_path__ + "static/media/profilePic.6b70dc7e.jpg";